import { Link } from "react-router-dom";
import { ArrowUpRight, Shield } from "lucide-react";
import { ALL_LINKS } from "@/lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-line bg-surface relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-16 mb-20">
          <div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white leading-[1.02] mb-8">
              Ready to review<br />the framework?
            </h2>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-flex items-center gap-3 bg-signal hover:bg-signal-hover text-white font-mono text-xs uppercase tracking-[0.15em] px-6 py-4 transition-colors"
            >
              Request More Information <ArrowUpRight size={15} />
            </Link>
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-mist">
              Email · <a href="mailto:gabriel.galvani@temrp.org" data-testid="footer-email" className="text-slate-300 hover:text-signal transition-colors normal-case tracking-normal text-sm font-body">gabriel.galvani@temrp.org</a>
            </p>
          </div>
          <div className="grid grid-cols-2 gap-10">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist mb-5">Program</p>
              <ul className="space-y-2.5">
                {ALL_LINKS.slice(1, 6).map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-slate-400 hover:text-white transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist mb-5">Institution</p>
              <ul className="space-y-2.5">
                {ALL_LINKS.slice(6).map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-slate-400 hover:text-white transition-colors">{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-line pt-10">
          <p className="text-xs text-mist leading-relaxed max-w-3xl mb-8">
            T-EMRP is a proposed pilot framework in pre-pilot status. It does not replace TECC, TCCC, NIMS, state EMS rules, local protocols, or a physician medical director. Any certification issued during the pilot is a local completion record — not a license, and not a nationally recognized credential.
          </p>
          <div className="flex flex-wrap items-center justify-between gap-6">
            <div className="flex items-center gap-3">
              <Shield size={14} className="text-signal" />
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-mist">
                © {new Date().getFullYear()} T-EMRP · Tactical Emergency Medical Readiness Program
              </span>
            </div>
            <div className="flex gap-6">
              <Link to="/privacy" data-testid="footer-privacy" className="font-mono text-[10px] uppercase tracking-[0.15em] text-mist hover:text-white transition-colors">Privacy</Link>
              <Link to="/terms" data-testid="footer-terms" className="font-mono text-[10px] uppercase tracking-[0.15em] text-mist hover:text-white transition-colors">Terms</Link>
              <Link to="/accessibility" data-testid="footer-accessibility" className="font-mono text-[10px] uppercase tracking-[0.15em] text-mist hover:text-white transition-colors">Accessibility</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
